import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import activitiesMixin from "@/mixins/task/activities";
import showUsers from "@/components/tasks/user/show_users.vue";
import moment from "moment";
export default {
  mixins: [activitiesMixin],
  props: {
    project: [Object],
    account: [Object],
    isUserVisible: {
      type: Boolean,
      default: true
    },
    focusSubject: {
      type: Boolean,
      default: true
    }
  },
  components: {
    showUsers: showUsers,
    vueMention: function vueMention() {
      return import("@/components/tasks/main/widgets/vue_mention");
    },
    kvTag: function kvTag() {
      return import("@/components/kiva/kvTag");
    }
  },
  data: function data() {
    return {
      show_mention: false,
      selectedEvent: {},
      focus: false,
      loading: false,
      options: {
        filters: {}
      }
    };
  },
  computed: {
    me: function me() {
      return this.$store.state.users.CURRENT_USER;
    }
  },
  created: function created() {
    moment.locale(this.$locale);
    this.listAll();
  },
  watch: {
    focusSubject: function focusSubject(val) {
      if (!val) {
        this.selectedEvent = {};
      }
    }
  },
  methods: {
    listAll: function listAll() {
      if (!this.options || !this.options.filters) {
        this.options = {
          filters: {}
        };
      }
      if (this.project && this.project.record_id) {
        this.options.filters.project = this.project.record_id;
      } else if (this.project && (typeof this.project == "number" || typeof this.project == "string")) {
        this.options.filters.project = this.project;
      }
      if (this.account && this.account.record_id) {
        this.options.filters.account = this.account.record_id;
      }
      this.getList(this.options);
    },
    checkDate: function checkDate(i) {
      var events = this.events;
      var current = this.events[i];
      var before = this.events[i - 1];
      var cDate = current ? moment(current.startDate).format("YYYY-MM-DD") : '';
      var bDate = before ? moment(before.startDate).format("YYYY-MM-DD") : '';
      if (i != 0 && cDate == bDate) {
        return false;
      }
      return true;
    },
    handleUpdate: function handleUpdate(command) {
      var _this = this;
      var note = this.events[command.i];
      if (command.command == "edit") {
        this.selectedEvent = note;
        this.$emit("setEdit", this.selectedEvent);
      } else if (command.command == "delete") {
        this.$confirm(this.$t("This will be deleted permanently. Continue?"), "Warning", {
          confirmButtonText: this.$t("Ok"),
          cancelButtonText: this.$t("Cancel"),
          type: "warning"
        }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this.deleteEvent(note.recordId);
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }))).catch(function () {
          _this.$message({
            type: "info",
            message: _this.$t("Delete canceled")
          });
        });
      }
    }
  }
};